<template>
  <a-form class="m-b-20" ref='form' :model='search' :initialValues="search" :onFinish='pageSearchChange'
    layout='inline'>
    <a-form-item label="出库单号" name='out_warehousing_sn'>
        <a-input style="width: 270px" v-model:value="search.out_warehousing_sn" placeholder="请输入关键词进行搜索" />
    </a-form-item>
    <a-form-item label="异常数量" name="sort">
        <a-select v-model:value="search.sort">
          <a-select-option value="DESC">从大到小排序</a-select-option>
          <a-select-option value="ASC">从小到到排序</a-select-option>
        </a-select>
    </a-form-item>
    <a-form-item>
      <a-button type="primary" htmlType='submit'>搜索</a-button>
    </a-form-item>
  </a-form>
  <p class="p-b-20">总异常扫码数量：{{allNum}}</p>
  <a-table :pagination='false' :loading='listLoading' bordered rowKey='out_warehousing_sn' :columns='columns' :data-source='list'>
    <template v-slot:action="{ record }">
      <a-button type="link" v-has:antiAuditWarningLog="()=> {$router.push('/antiFleeingGoods/marketAudit/warningDetails?type=order&id='+record.out_warehousing_sn+'&name='+record.out_warehousing_sn)}">查看全部记录</a-button>
      <a-button type="link" v-has:antiAuditWarningDisabled='()=>status(record)'>{{record.fleeing_goods_status?'禁用':'启用'}}</a-button>
    </template>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page"
    :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `"  />
</template>
<script>
  import { onMounted, inject } from "vue";
  import { getRouter } from "@/utils/app";
  import { getPageState } from "@/utils/pageState";
  import { iscode } from "@/utils/app";
  import useTableSearch from "@/hooks/useTableSearch";
  import { fleeingWarningOut ,setFleeingWarningStatus} from "@/api/antiFleeing";
  // 初始化默认筛选项数值
  let defSearch = {
    page: 1,
    limit: 10,
    out_warehousing_sn: "",
    sort:'DESC'
  };
  export default {
    components: { },
    setup() {
      let columns = [
        {
          title: "总部出库单号",
          dataIndex: "out_warehousing_sn",
          key: "out_warehousing_sn",
        },
        {
          title: "状态",
          dataIndex: "fleeing_goods_status",
          key: "fleeing_goods_status",
          customRender:({record})=>{
            return record.fleeing_goods_status ? '启用':'禁用'
          } 
        },
        {
          title: "异常扫码数量",
          dataIndex: "scan_ex_num",
          key: "scan_ex_num",
        },
        {
          title: "操作",
          key: "action",
          width:250,
          slots: { customRender: "action" },
        },
      ];
      const $router = inject("$router");
      const $Modal = inject("$Modal");
      // 启用/禁用
      const status = (e) => {
        $Modal.confirm({
          centered: true,
          title:'确定'+(e.fleeing_goods_status ? '禁用':'启用')+'订单二维码？',
          onOk: async () => {
            let res = await setFleeingWarningStatus(e.out_warehousing_sn).then((res) => res.data).catch(error => error);
            if (iscode(res, true)) {
              tableHoosks.initData(fleeingWarningOut, search.value);
            }
          },
        });
      };
      const {
        pageCurrentChange,
        pageSizeChange,
        search,
        list,
        initData,
        total,
        allNum,
        pageSearchChange,
        listLoading,
      } = useTableSearch({ data: defSearch });
      const tableHoosks = {
        pageCurrentChange,
        pageSizeChange,
        search,
        initData,
        list,
        total,
        allNum,
        pageSearchChange,
        listLoading,
      };

      onMounted(() => {
        // 查看是否有留存状态，有则替换
        let pageState = getPageState(getRouter().route.path);
        if (pageState) {
          search.value = Object.assign(search.value, pageState);
        }
        tableHoosks.initData(fleeingWarningOut, search.value);
      });
      return {
        ...tableHoosks,
        columns,
        status
      };
    },
  };
</script>